import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../../shared/colors";

const useStyles = makeStyles((theme) => ({

    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundColor: colors.dhcsYellow
    },
    completed: {
        backgroundColor: colors.dhcsBlue,
    }

}));


export default useStyles;
